/**
 * @generated SignedSource<<2a63fdf06810740597bfaeb2f2d23878>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSearches_itemSearch$data = {
  readonly relatedSearches: ReadonlyArray<{
    readonly anchorText: string | null;
    readonly url: string | null;
  } | null> | null;
  readonly " $fragmentType": "SbSharedRelatedSearches_itemSearch";
};
export type SbSharedRelatedSearches_itemSearch$key = {
  readonly " $data"?: SbSharedRelatedSearches_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSearches_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSearches_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RelatedSearch",
      "kind": "LinkedField",
      "name": "relatedSearches",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "anchorText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "36860d0a1909b8fd27abf5f83703848e";

export default node;
